// extracted by mini-css-extract-plugin
export var borderRadius = "_6q-4";
export var large = "_6q-3";
export var logoContainer = "_6q-0";
export var nameLogo = "_6q-2";
export var small = "_6q-1";